export const CanceledTemplate = {
    name: 'canceled',
    label: 'Canceled',
    subject: "REBIT ${reference}: Canceled!",
    category: 'compulsory',
    body: "<p style='padding:10px;background-color: #ffebe6'>⛔️ <b>Your Rebit order with reference ${reference} has been cancelled.</b></p>"
        + "<p>If you think that is a mistake, or you already paid to Rebit bank account please contact us by replying to this email (<a href='mailto:support@rebit.co.nz'>support@rebit.co.nz</a>) or call us on <b>+64221248180</b> in New Zealand. (Also available on WhatsApp & Telegram with same number)</p>"
}

